// extracted by mini-css-extract-plugin
module.exports =  {"content":"FullScreenErrorWrapper__content--V7"};